import myoshLogo from '../assets/myosh-logo-white-text.svg';

const Sidebar = () => {
  return (
    <aside
      data-testid="login-sidebar"
      className="from-secondary-1 via-secondary-2 to-secondary-1 flex w-full flex-col bg-gradient-to-br sm:max-w-xs"
    >
      <img src={myoshLogo} alt="myosh HSEQ Management Software" className="mx-6 my-4 w-40" />
      <h1 className="text-md text-mono-1 mx-6 font-bold drop-shadow-lg sm:text-lg md:text-xl">
        Safety &amp; Compliance software for every business
      </h1>
    </aside>
  );
};

export default Sidebar;
